// extracted by mini-css-extract-plugin
export default {"root":"PlasmicModuleNavLogo_root__+nHIV","buttonNav":"PlasmicModuleNavLogo_buttonNav__pym9w","img":"PlasmicModuleNavLogo_img__niNzp"};